import React from 'react';
import { GitCommit, TrendingDown, TrendingUp } from 'react-feather';

interface Props {
  current: number;
  previous: number;
}

const Trending = ({ current, previous }: Props) => {
  return (
    <div>
      {current > previous ? (
        <TrendingUp className="text-green-300" size={16} />
      ) : current < previous ? (
        <TrendingDown className="text-red-300" size={16} />
      ) : (
        <GitCommit className="text-blue-500" size={16} />
      )}
    </div>
  );
};

export default Trending;
